@if (!isEditing_()) {
	<div class="flex items-center gap-4 mb-4">
		<div>
			<strong class="text-lg font-medium">Tenants</strong>
		</div>

		<div>
			@if (!showForm_()) {
				<app-button
					size="small"
					[icon]="ICON.ADD"
					btn="border"
					(click)="add()"
					[testHook]="testHooks.AddTenantButton"
					>Add Tenant</app-button
				>
			}
		</div>
	</div>
}

@if (showForm_()) {
	<app-container class="mb-4" [class]="isEditing_() ? 'no-container' : null">
		<div class="grid grid-cols-2 gap-4">
			<div>
				<app-input
					#fullName
					label="Tenant Name"
					[ngModel]="form_()?.fullName"
					[required]="true"
					(debounce)="updateField($event, 'fullName')"
					[testHook]="testHooks.TenantName"
				></app-input>
			</div>
			<div>
				<app-input
					label="Phone Number"
					[ngModel]="form_()?.phoneNumber"
					(debounce)="updateField($event, 'phoneNumber')"
					[testHook]="testHooks.PhoneNumber"
				></app-input>
			</div>
			<div>
				<app-date-picker
					label="Lease Start date"
					[ngModel]="form_()?.leaseStartDate"
					(ngModelChange)="updateField($event, 'leaseStartDate')"
					[maxDate]="form_()?.leaseEndDate"
					[testHook]="testHooks.LeaseStartDate"
				></app-date-picker>
			</div>
			<div>
				<app-date-picker
					label="Lease end date"
					[ngModel]="form_()?.leaseEndDate"
					(ngModelChange)="updateField($event, 'leaseEndDate')"
					[minDate]="form_()?.leaseStartDate"
					[testHook]="testHooks.LeaseEndDate"
				></app-date-picker>
			</div>
			<div>
				<app-input
					label="Rent"
					type="cents"
					[endIcon]="ICON.DOLLAR"
					[ngModel]="form_()?.rentAmount"
					(debounce)="updateField($event, 'rentAmount')"
					[testHook]="testHooks.Rent"
				></app-input>
			</div>
			<div>
				<app-input
					label="Deposit"
					type="cents"
					[endIcon]="ICON.DOLLAR"
					[ngModel]="form_()?.depositAmount"
					(debounce)="updateField($event, 'depositAmount')"
					[testHook]="testHooks.Deposit"
				></app-input>
			</div>
		</div>

		<div
			[class]="isEditing_() ? 'mt-8' : 'mt-4'"
			class="flex justify-end gap-2"
		>
			<app-button
				size="small"
				btn="border"
				(click)="cancel()"
				[testHook]="testHooks.CancelButton"
			>
				Cancel</app-button
			>

			<app-button
				size="small"
				btn="border"
				(click)="save()"
				[testHook]="testHooks.SaveButton"
			>
				Save</app-button
			>
		</div>
	</app-container>
}
